import {
    initializeLocationCardIfNeeded,
    initializePlace,
    fetchLocationDetails,
} from '../actions/locationCardActions';
import { isLocationInCache } from '../selectors/locationCardSelectors';
import { setViewState } from 'owa-location-card-v2/lib/mutators/locationCardMutators';
import { orchestrator } from 'satcheljs';

/**
 * Initialize the location card and fetches the location from the server if it is not fully loaded
 */
export default orchestrator(initializeLocationCardIfNeeded, async actionMessage => {
    const {
        name,
        postalAddress,
        locationId,
        locationType,
        colorScheme,
        phoneNumber,
    } = actionMessage;

    if (isLocationInCache(locationId)) {
        // Skip the initialization if the location is already present in the cache
        return;
    }

    initializePlace(name, postalAddress, locationId, locationType, phoneNumber);
    setViewState({
        isLoading: false,
        isDataLoaded: false,
        colorScheme: colorScheme,
    });

    fetchLocationDetails(locationId);
});
